<template>
  <div class="dasboard-mp">
    <!-- <b-row> -->
      <!-- <b-col class="col-md-6">
        <b-card no-body>
          <b-card-body>
            <div class="col-12">
              <h4 class="font-weight-bolder">
                {{ (internal === 0) ? 'TOP UP' : 'Earning' }} Information
              </h4>
            </div> -->
            <!-- <div class="col-12 d-flex justify-content-around flex-column flex-md-row"> -->
              <!-- <div class="col-12 col-md-4 border border-2 border-primary p-1 rounded m-25"> -->
                <!-- <div class="truncate"> -->
                <!-- <h6 class="mb-25 font-weight-bolder">
                  IDR {{ formatPrice(dataEarning.today) }}
                </h6>
                <span class="font-small-2">Today TOP UP</span> -->
                <!-- </div> -->
              <!-- </div> -->
              <!-- <div class="col-12 col-md-4 border border-2 border-primary p-1 rounded m-25"> -->
                <!-- <div class="truncate"> -->
                <!-- <h6 class="mb-25 font-weight-bolder">
                  IDR {{ formatPrice(dataEarning.thismonth) }}
                </h6>
                <span class="font-small-2">This Month TOP UP</span> -->
                <!-- </div> -->
              <!-- </div> -->
              <!-- <div class="col-12 col-md-4 border border-2 border-primary p-1 rounded m-25"> -->
                <!-- <div class="truncate"> -->
                <!-- <h6 class="mb-25 font-weight-bolder">
                  IDR {{ formatPrice(dataEarning.lastmonth) }}
                </h6>
                <span class="font-small-2">Last Month TOP UP</span> -->
                <!-- </div> -->
              <!-- </div> -->
            <!-- </div> -->
          <!-- </b-card-body>
        </b-card>
      </b-col> -->
      <!-- <b-col class="col-md-6">
        <b-card no-body>
          <b-card-body>
            <div class="col-12">
              <h4 class="font-weight-bolder">
                Spending Information
              </h4>
            </div> -->
            <!-- <div class="col-12 d-flex justify-content-around flex-column flex-md-row"> -->
              <!-- <div class="col-12 col-md-4 border border-2 border-primary p-1 rounded m-25"> -->
                <!-- <div class="truncate"> -->
                <!-- <h6 class="mb-25 font-weight-bolder">
                  IDR {{ formatPrice(dataSpending.today) }}
                </h6> -->
                <!-- <span class="font-small-2">Today Spending</span> -->
                <!-- </div> -->
              <!-- </div> -->
              <!-- <div class="col-12 col-md-4 border border-2 border-primary p-1 rounded m-25"> -->
                <!-- <div class="truncate"> -->
                <!-- <h6 class="mb-25 font-weight-bolder">
                  IDR {{ formatPrice(dataSpending.thismonth) }}
                </h6> -->
                <!-- <span class="font-small-2">This Month Spending</span> -->
                <!-- </div> -->
              <!-- </div> -->
              <!-- <div class="col-12 col-md-4 border border-2 border-primary p-1 rounded m-25"> -->
                <!-- <div class="truncate"> -->
                <!-- <h6 class="mb-25 font-weight-bolder">
                  IDR {{ formatPrice(dataSpending.lastmonth) }}
                </h6> -->
                <!-- <span class="font-small-2">Last Month Spending</span> -->
                <!-- </div> -->
              <!-- </div> -->
            <!-- </div> -->
          <!-- </b-card-body>
        </b-card>
      </b-col> -->
    <!-- </b-row> -->
    <b-row
      v-if="dept===15"
      class="match-height"
    >
      <b-col
        lg="4"
        md="12"
        sm="12"
      >
        <b-card
          no-body
          text-variant="white"
          class="bg1-color"
        >
          <b-card-body
            class="d-flex justify-content-between align-items-center py-0"
          >
            <div class="truncate">
              <h2 class="mb-25 font-weight-bolder text-white">
                IDR {{ formatPrice(dataTodayRevenue.total) }}
              </h2>
              <span>{{ dataTodayRevenue.time }}</span>
            </div>
            <b-avatar
              variant="light-secondary"
              size="75"
            >
              <svg
                width="40"
                height="40"
                viewBox="0 0 40 40"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M8.75 0C9.08152 0 9.39946 0.131696 9.63388 0.366117C9.8683 0.600537 10 0.918479 10 1.25V2.5H30V1.25C30 0.918479 30.1317 0.600537 30.3661 0.366117C30.6005 0.131696 30.9185 0 31.25 0C31.5815 0 31.8995 0.131696 32.1339 0.366117C32.3683 0.600537 32.5 0.918479 32.5 1.25V2.5H35C36.3261 2.5 37.5979 3.02678 38.5355 3.96447C39.4732 4.90215 40 6.17392 40 7.5V35C40 36.3261 39.4732 37.5979 38.5355 38.5355C37.5979 39.4732 36.3261 40 35 40H5C3.67392 40 2.40215 39.4732 1.46447 38.5355C0.526784 37.5979 0 36.3261 0 35V7.5C0 6.17392 0.526784 4.90215 1.46447 3.96447C2.40215 3.02678 3.67392 2.5 5 2.5H7.5V1.25C7.5 0.918479 7.6317 0.600537 7.86612 0.366117C8.10054 0.131696 8.41848 0 8.75 0V0ZM2.5 10V35C2.5 35.663 2.76339 36.2989 3.23223 36.7678C3.70107 37.2366 4.33696 37.5 5 37.5H35C35.663 37.5 36.2989 37.2366 36.7678 36.7678C37.2366 36.2989 37.5 35.663 37.5 35V10H2.5Z"
                  fill="black"
                  fill-opacity="0.15"
                />
              </svg>
            </b-avatar>
          </b-card-body>
          <b-card-footer class="text-center py-1 ds">
            <span
              v-if="(role === 1 || role === 2) && (dept === 1 || dept === 3|| dept === 5)"
            >
              Today Revenue</span>
            <span v-if="role === 3 && internal === 0"> Today Spending</span>
          </b-card-footer>
        </b-card>
      </b-col>
      <b-col
        lg="4"
        md="12"
        sm="12"
      >
        <b-card
          no-body
          text-variant="white"
          class="bg2-color"
        >
          <b-card-body
            class="d-flex justify-content-between align-items-center py-0"
          >
            <div class="truncate">
              <h2 class="mb-25 font-weight-bolder text-white">
                IDR {{ formatPrice(dataThisMonthRevenue.total) }}
              </h2>
              <span>{{ dataThisMonthRevenue.time }}</span>
            </div>
            <b-avatar
              variant="light-secondary"
              size="75"
            >
              <svg
                width="40"
                height="40"
                viewBox="0 0 40 40"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M27.5 16.25C27.5 15.9185 27.6317 15.6005 27.8661 15.3661C28.1005 15.1317 28.4185 15 28.75 15H31.25C31.5815 15 31.8995 15.1317 32.1339 15.3661C32.3683 15.6005 32.5 15.9185 32.5 16.25V18.75C32.5 19.0815 32.3683 19.3995 32.1339 19.6339C31.8995 19.8683 31.5815 20 31.25 20H28.75C28.4185 20 28.1005 19.8683 27.8661 19.6339C27.6317 19.3995 27.5 19.0815 27.5 18.75V16.25ZM20 16.25C20 15.9185 20.1317 15.6005 20.3661 15.3661C20.6005 15.1317 20.9185 15 21.25 15H23.75C24.0815 15 24.3995 15.1317 24.6339 15.3661C24.8683 15.6005 25 15.9185 25 16.25V18.75C25 19.0815 24.8683 19.3995 24.6339 19.6339C24.3995 19.8683 24.0815 20 23.75 20H21.25C20.9185 20 20.6005 19.8683 20.3661 19.6339C20.1317 19.3995 20 19.0815 20 18.75V16.25ZM7.5 23.75C7.5 23.4185 7.6317 23.1005 7.86612 22.8661C8.10054 22.6317 8.41848 22.5 8.75 22.5H11.25C11.5815 22.5 11.8995 22.6317 12.1339 22.8661C12.3683 23.1005 12.5 23.4185 12.5 23.75V26.25C12.5 26.5815 12.3683 26.8995 12.1339 27.1339C11.8995 27.3683 11.5815 27.5 11.25 27.5H8.75C8.41848 27.5 8.10054 27.3683 7.86612 27.1339C7.6317 26.8995 7.5 26.5815 7.5 26.25V23.75ZM15 23.75C15 23.4185 15.1317 23.1005 15.3661 22.8661C15.6005 22.6317 15.9185 22.5 16.25 22.5H18.75C19.0815 22.5 19.3995 22.6317 19.6339 22.8661C19.8683 23.1005 20 23.4185 20 23.75V26.25C20 26.5815 19.8683 26.8995 19.6339 27.1339C19.3995 27.3683 19.0815 27.5 18.75 27.5H16.25C15.9185 27.5 15.6005 27.3683 15.3661 27.1339C15.1317 26.8995 15 26.5815 15 26.25V23.75Z"
                  fill="black"
                  fill-opacity="0.15"
                />
                <path
                  d="M8.75 0C9.08152 0 9.39946 0.131696 9.63388 0.366117C9.8683 0.600537 10 0.918479 10 1.25V2.5H30V1.25C30 0.918479 30.1317 0.600537 30.3661 0.366117C30.6005 0.131696 30.9185 0 31.25 0C31.5815 0 31.8995 0.131696 32.1339 0.366117C32.3683 0.600537 32.5 0.918479 32.5 1.25V2.5H35C36.3261 2.5 37.5979 3.02678 38.5355 3.96447C39.4732 4.90215 40 6.17392 40 7.5V35C40 36.3261 39.4732 37.5979 38.5355 38.5355C37.5979 39.4732 36.3261 40 35 40H5C3.67392 40 2.40215 39.4732 1.46447 38.5355C0.526784 37.5979 0 36.3261 0 35V7.5C0 6.17392 0.526784 4.90215 1.46447 3.96447C2.40215 3.02678 3.67392 2.5 5 2.5H7.5V1.25C7.5 0.918479 7.6317 0.600537 7.86612 0.366117C8.10054 0.131696 8.41848 0 8.75 0V0ZM2.5 10V35C2.5 35.663 2.76339 36.2989 3.23223 36.7678C3.70107 37.2366 4.33696 37.5 5 37.5H35C35.663 37.5 36.2989 37.2366 36.7678 36.7678C37.2366 36.2989 37.5 35.663 37.5 35V10H2.5Z"
                  fill="black"
                  fill-opacity="0.15"
                />
              </svg>

            </b-avatar>
          </b-card-body>
          <b-card-footer class="text-center py-1 ds">
            <span
              v-if="(role === 1 || role === 2) && (dept === 1 || dept === 3 || dept === 5)"
            >
              This Month Revenue</span>
            <span v-if="role === 3 && internal === 0">
              This Month Spending</span>
          </b-card-footer>
        </b-card>
      </b-col>
      <b-col
        lg="4"
        md="12"
        sm="12"
      >
        <b-card
          no-body
          text-variant="white"
          class="bg3-color"
        >
          <b-card-body
            class="d-flex justify-content-between align-items-center py-0"
          >
            <div class="truncate">
              <h2 class="mb-25 font-weight-bolder text-white">
                IDR {{ formatPrice(dataLastMonthRevenue.total) }}
              </h2>
              <span>{{ dataLastMonthRevenue.time }}</span>
            </div>
            <b-avatar
              variant="light-secondary"
              size="75"
            >
              <svg
                width="40"
                height="40"
                viewBox="0 0 40 40"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M27.1346 17.8648C27.251 17.9809 27.3434 18.1188 27.4064 18.2707C27.4694 18.4226 27.5019 18.5854 27.5019 18.7498C27.5019 18.9142 27.4694 19.077 27.4064 19.2289C27.3434 19.3807 27.251 19.5187 27.1346 19.6348L19.6346 27.1348C19.5185 27.2512 19.3806 27.3436 19.2287 27.4066C19.0768 27.4696 18.914 27.502 18.7496 27.502C18.5852 27.502 18.4224 27.4696 18.2705 27.4066C18.1187 27.3436 17.9807 27.2512 17.8646 27.1348L14.1146 23.3848C13.9984 23.2686 13.9062 23.1306 13.8433 22.9788C13.7804 22.8269 13.748 22.6642 13.748 22.4998C13.748 22.3354 13.7804 22.1727 13.8433 22.0208C13.9062 21.869 13.9984 21.731 14.1146 21.6148C14.3493 21.3801 14.6677 21.2482 14.9996 21.2482C15.164 21.2482 15.3267 21.2806 15.4786 21.3435C15.6304 21.4064 15.7684 21.4986 15.8846 21.6148L18.7496 24.4823L25.3646 17.8648C25.4807 17.7484 25.6187 17.656 25.7705 17.593C25.9224 17.53 26.0852 17.4976 26.2496 17.4976C26.414 17.4976 26.5768 17.53 26.7287 17.593C26.8806 17.656 27.0185 17.7484 27.1346 17.8648Z"
                  fill="black"
                  fill-opacity="0.15"
                />
                <path
                  d="M8.75 0C9.08152 0 9.39946 0.131696 9.63388 0.366117C9.8683 0.600537 10 0.918479 10 1.25V2.5H30V1.25C30 0.918479 30.1317 0.600537 30.3661 0.366117C30.6005 0.131696 30.9185 0 31.25 0C31.5815 0 31.8995 0.131696 32.1339 0.366117C32.3683 0.600537 32.5 0.918479 32.5 1.25V2.5H35C36.3261 2.5 37.5979 3.02678 38.5355 3.96447C39.4732 4.90215 40 6.17392 40 7.5V35C40 36.3261 39.4732 37.5979 38.5355 38.5355C37.5979 39.4732 36.3261 40 35 40H5C3.67392 40 2.40215 39.4732 1.46447 38.5355C0.526784 37.5979 0 36.3261 0 35V7.5C0 6.17392 0.526784 4.90215 1.46447 3.96447C2.40215 3.02678 3.67392 2.5 5 2.5H7.5V1.25C7.5 0.918479 7.6317 0.600537 7.86612 0.366117C8.10054 0.131696 8.41848 0 8.75 0V0ZM2.5 10V35C2.5 35.663 2.76339 36.2989 3.23223 36.7678C3.70107 37.2366 4.33696 37.5 5 37.5H35C35.663 37.5 36.2989 37.2366 36.7678 36.7678C37.2366 36.2989 37.5 35.663 37.5 35V10H2.5Z"
                  fill="black"
                  fill-opacity="0.15"
                />
              </svg>

            </b-avatar>
          </b-card-body>
          <b-card-footer class="text-center py-1 ds">
            <span
              v-if="(role === 1 || role === 2) && (dept === 1 || dept === 3 || dept === 5)"
            >
              Last Month Revenue</span>
            <span v-if="role === 3 && internal === 0">
              Last Month Spending</span>
          </b-card-footer>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-card>
          <p class="t-ms">
            Display Data by:
          </p>
          <b-button-group size="sm">
            <b-button
              :class="seriActive === 'today' ? 'active' : ''"
              variant="outline-primary mpx"
              @click="actionFilter('today')"
            >
              Today
            </b-button>
            <b-button
              :class="seriActive === 'yesterday' ? 'active' : ''"
              variant="outline-primary mpx"
              @click="actionFilter('yesterday')"
            >
              Yesterday
            </b-button>
            <b-button
              :class="seriActive === 'last7days' ? 'active' : ''"
              variant="outline-primary mpx"
              @click="actionFilter('last7days')"
            >
              Last 7 Days
            </b-button>
            <b-button
              :class="seriActive === 'thismonth' ? 'active' : ''"
              variant="outline-primary mpx"
              @click="actionFilter('thismonth')"
            >
              This Month
            </b-button>
          </b-button-group>
        </b-card>
      </b-col>
    </b-row>
    <b-row class="match-height chart-start">
      <b-col
        xl="6"
        lg="6"
        sm="6"
        xs="12"
        class="col-chart"
      >
        <chart-bar
          ref="trafficPerform"
          feather="eye"
          :data-cart="dataTrafficPerfom"
          :horizontal="typeHorizontal"
          :total="total"
          :color="color1"
        />
      </b-col>

      <b-col
        xl="6"
        lg="6"
        sm="6"
        xs="12"
        class="col-chart"
      >
        <chart-bar
          ref="clickPerform"
          feather="click"
          :data-cart="dataClickPerfom"
          :horizontal="typeVertical"
          :total="total"
          :color="color2"
        />
      </b-col>

      <!-- <b-col
        xl="4"
        lg="6"
        sm="6"
        xs="12"
        class="col-chart"
      >
        <chart-bar
          ref="salesPerform"
          feather="dollar"
          :data-cart="dataSalesconversion"
          :horizontal="typeHorizontal"
          :total="total"
          :color="color3"
        />
      </b-col> -->

      <b-col
        xl="6"
        lg="6"
        sm="6"
        xs="12"
        class="col-chart"
      >
        <chart-bar
          ref="mostInventory"
          :data-cart="dataMostInventory"
          :horizontal="typeHorizontal"
          :padding="padding"
        />
      </b-col>

      <b-col
        xl="6"
        lg="6"
        sm="6"
        xs="12"
        class="col-chart"
      >
        <cart-map
          ref="mostPurchase"
          :data-cart="dataMostPurchase"
          :padding="padding"
        />
      </b-col>

      <!-- <b-col
        xl="4"
        lg="6"
        sm="6"
        xs="12"
        class="col-chart"
      >
        <chart-bar
          ref="mostIndustry"
          :data-cart="dataMostIndustry"
          :horizontal="typeVertical"
          :padding="padding"
        />
      </b-col> -->
    </b-row>

    <b-row
      v-if="internal === 0"
      class="match-height list-btn"
    >
      <!-- <b-col
        xl="2"
        lg="2"
        md="4"
        sm="6"
        class="col-chart"
      >
        <b-card>
          <span>Buy Now!</span>
          <b-button
            block
            class="py-1 color-1"
            @click="actionButton(4)"
          >
            <span class="align-middle">Digital Ads Banner</span> -->
            <!-- <feather-icon
              icon="ArrowRightCircleIcon"
              class="ml-50 align-middle"
            /> -->
          <!-- </b-button>
        </b-card>
      </b-col> -->

      <!-- <b-col
        xl="2"
        lg="2"
        md="4"
        sm="6"
        class="col-chart"
      >
        <b-card>
          <span>Buy Now!</span>
          <b-button
            block
            class="py-1 color-2"
            @click="notAvailable()"
          >
            <span
              class="align-middle"
            >In App<br>
              Notification</span> -->
            <!-- <feather-icon
              icon="ArrowRightCircleIcon"
              class="ml-50 align-middle"
            /> -->
          <!-- </b-button>
        </b-card>
      </b-col> -->

      <b-col
        xl="2"
        lg="2"
        md="4"
        sm="6"
        class="col-chart"
      >
        <b-card>
          <span>Buy Now!</span>
          <b-button
            block
            class="py-1 color-3"
            @click="actionButton(3)"
          >
            <span class="align-middle">Flash Message</span>
            <!-- <feather-icon
              icon="ArrowRightCircleIcon"
              class="ml-50 align-middle"
            /> -->
          </b-button>
        </b-card>
      </b-col>

      <!-- <b-col
        xl="2"
        lg="2"
        md="4"
        sm="6"
        class="col-chart"
      >
        <b-card>
          <span>Buy Now!</span>
          <b-button
            block
            class="py-1 color-4"
            @click="actionButton(2)"
          >
            <span class="align-middle">USSD</span> -->
            <!-- <feather-icon
              icon="ArrowRightCircleIcon"
              class="ml-50 align-middle"
            /> -->
          <!-- </b-button>
        </b-card>
      </b-col> -->

      <!-- <b-col
        xl="2"
        lg="2"
        md="4"
        sm="6"
        class="col-chart"
      >
        <b-card>
          <span>Buy Now!</span>
          <b-button
            block
            class="py-1 color-5"
            @click="notAvailable()"
          >
            <span class="align-middle">In Browser Notification</span>
          </b-button>
        </b-card>
      </b-col> -->

      <b-col
        xl="2"
        lg="2"
        md="4"
        sm="6"
        class="col-chart"
      >
        <b-card>
          <span>Buy Now!</span>
          <b-button
            block
            class="py-1 color-6"
            @click="actionButton(1)"
          >
            <span class="align-middle">SMS</span>
            <!-- <feather-icon
              icon="ArrowRightCircleIcon"
              class="ml-50 align-middle"
            /> -->
          </b-button>
        </b-card>
      </b-col>
    </b-row>
    <!-- <b-row class="match-height">
      <b-col cols="12">
        <b-card no-body>
          <b-card-header>
            <div>
              <b-card-title class="font-weight-bolder mb-1">
                Live Campaign Summary
              </b-card-title>
              <b-card-sub-title>
                Campaign Perform Summary
              </b-card-sub-title>
            </div>
          </b-card-header>
          <b-card-body>
            <data-table
              :data-table="dataCampaignDashboardItem"
              :field-table="dataCampaignDashboardField"
              :status="dataCampaignDashboardStatus"
              :tool="tool"
              :information="info"
              :pagination="pagination"
            />
          </b-card-body>
        </b-card>
      </b-col>
    </b-row> -->
    <account-list
      v-if="(role === 2) & (dept === 1)"
      :status-account="status"
      :from-page="page"
      :title="title"
    />
  </div>
</template>
<script>
import {
  BRow,
  BCol,
  BCard,
  BButton,
  BButtonGroup,
  BAvatar,
  // BCardHeader,
  BCardBody,
  BCardFooter,
  // BCardTitle,
  // BCardSubTitle,
} from 'bootstrap-vue'
import chartBar from '@/views/component/cart/CartBar.vue'
import cartMap from '@/views/component/cart/CartMap.vue'
// import customBar from '@/views/component/cart/CustomCartBar.vue'
// import DataTable from '@/views/component/DataTable.vue'
import accountList from '@/views/page/account/List.vue'
import { mapActions, mapGetters } from 'vuex'

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BAvatar,
    // BCardHeader,
    // BCardTitle,
    // BCardSubTitle,
    BCardBody,
    BCardFooter,
    BButton,
    BButtonGroup,
    chartBar,
    cartMap,
    // customBar,
    // DataTable,
    accountList,
  },
  data() {
    return {
      typeHorizontal: true,
      typeVertical: false,
      padding: false,
      tool: false,
      info: false,
      pagination: false,
      tabelFor: 'campaign',
      internal: this.$store.state.auth.userData.data.company.internal_company,
      dept: this.$store.state.auth.userData.data.departement.id,
      role: this.$store.state.auth.userData.data.Account.role_id,
      status: 1,
      page: true,
      title: 'New Partner Approval',
      seriActive: 'today',
      total: true,
      color1: 'bg-color-1',
      color2: 'bg-color-2',
      color3: 'bg-color-3',
      revenueToday: {
        total: 0,
        time: '',
      },
      revenueThisMonth: {
        total: 0,
        time: '',
      },
      revenueLastMont: {
        total: 0,
        time: '',
      },
    }
  },
  computed: {
    ...mapGetters('dashboard', {
      dataTrafficPerfom: 'getTrafficPerformData',
      dataClickPerfom: 'getClickPerformData',
      dataSalesconversion: 'getSalesConversionData',
      dataMostInventory: 'getMostInventoryData',
      dataMostPurchase: 'getMostPurchaseData',
      dataMostIndustry: 'getMostIndustryData',
      dataTodayRevenue: 'getRevenueToday',
      dataThisMonthRevenue: 'getRevenueThisMonth',
      dataLastMonthRevenue: 'getRevenueLastMonth',
      dataSpending: 'getSpending',
      dataEarning: 'getEarning',
      // dataCampaignItem: 'getCampaignItem',
      // dataCampaignStatus: 'getCampaignStatus',
    }),
    ...mapGetters('campaign', {
      dataCampaignDashboardField: 'getCampaignDashboardField',
      dataCampaignDashboardItem: 'getCampaignDashboardItem',
      dataCampaignDashboardStatus: 'getCampaignDashboardStatus',
    }),
    ...mapGetters('auth', {
      getRole: 'getRole',
    }),
  },
  beforeMount() {
    // this.getTodayRevenue(this.role)
    // this.getThisMonthRevenue(this.role)
    // this.getLastMonthRevenue(this.role)
    this.getEarningSpending()
    // this.$forceUpdate()
  },
  mounted() {
    this.getAdditionalData()
    this.actionFilter('today')
  },
  // beforeUpdate() {
  //   this.revenueToday = this.dataTodayRevenue
  //   this.revenueThisMonth = this.dataThisMonthRevenue
  //   this.revenueLastMont = this.dataLastMonthRevenue
  // },
  methods: {
    ...mapActions('dashboard', [
      'getTrafficPerform',
      'getClickPerform',
      'getSalesConversion',
      'getMostInventory',
      'getMostPurchase',
      'getMostIndustry',
      'getTodayRevenue',
      'getThisMonthRevenue',
      'getLastMonthRevenue',
      'getEarningSpending',
    ]),
    ...mapActions('campaign', ['getDataCampaign']),
    ...mapActions('datas', ['getAdditionalData']),
    actionButton(channel) {
      this.$store.state.campaign.formCampaign.channel_id = channel
      this.$router.push({ name: 'create-campaign' })
    },
    notAvailable() {
      this.$swal({
        title: 'Coming Soon!',
        text: '',
        icon: 'warning',
        customClass: {
          confirmButton: 'btn btn-primary',
        },
        buttonsStyling: false,
      })
    },
    actionFilter(active) {
      this.seriActive = active
      this.$refs.trafficPerform.actionFilter(active)
      this.$refs.clickPerform.actionFilter(active)
      // this.$refs.salesPerform.actionFilter(active)
      this.$refs.mostInventory.actionFilter(active)
      // this.$refs.mostIndustry.actionFilter(active)
      this.$refs.mostPurchase.actionFilter(active)
    },
    formatPrice(value) {
      if (value === null || typeof value === 'undefined') {
        return 0
      }
      let val = (value / 1).toFixed(0).replace('.', ',')
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    },
  },
}
</script>

<style scoped>
/* @media only screen and (min-width: 992px) {
   .list-btn button{
      font-size:0.9em;
  }
}
@media only screen and (min-width: 1200px) {
   .list-btn button{
      font-size:0.7em;
  }
}
@media only screen and (min-width: 1800px) {
   .list-btn button{
      font-size:1em;
  }
} */
.chart-start .card {
  margin-bottom: 1rem;
}
/*.col-chart{
    padding-right: 0.5rem;
    padding-left: 0.5rem;
}
.chart-start, .chart-start .row{
  margin-right: -0.5rem;
  margin-left: -0.5rem;
}*/
.t-ms{
  color: #5e5873;
  margin-bottom: 0.5rem;
  font-weight: 600;
}
.mpx,.mpx:not(:disabled):not(.disabled):active, .mpx:not(:disabled):not(.disabled).active, .mpx:not(:disabled):not(.disabled):focus{
  color: #5e5873 !important;
  font-weight: 600;
}
</style>
